/**
 * Badge del tipo de ausencia (008 · T076; contracts/ui.md §1.5 y §2.2): tono Info con **icono +
 * texto** (design-system §10: nunca solo color). Iconos compartidos con la celda del cuadro
 * (`ABSENCE_ICONS`): Permiso `file-clock`, Vacaciones `plane`, Licencia `file-text`, Descanso
 * médico `stethoscope`. Un permiso por horas añade "por horas".
 */
import type { AbsenceType } from '@fermin/contracts';

import { t } from '../../i18n';
import { cn } from '../../lib/cn';
import { ABSENCE_ICONS } from '../schedules/grid/grid-cell';

export interface AbsenceTypeBadgeProps {
  type: AbsenceType;
  partial?: boolean;
  className?: string;
}

/** "Vacaciones" / "Permiso por horas". */
export function absenceTypeLabel(type: AbsenceType, partial = false): string {
  const label = t(`absences.types.${type}`);
  return partial ? t('absences.types.partial', { type: label }) : label;
}

export function AbsenceTypeBadge({ type, partial = false, className }: AbsenceTypeBadgeProps) {
  const Icon = ABSENCE_ICONS[type];
  return (
    <span
      data-testid="absence-type-badge"
      data-type={type}
      className={cn(
        'inline-flex items-center gap-fm-1 rounded-fm-pill bg-fm-info-soft px-fm-2 py-px text-fm-xs font-medium text-fm-info-text',
        className,
      )}
    >
      <Icon size={12} aria-hidden="true" />
      {absenceTypeLabel(type, partial)}
    </span>
  );
}
